import React, { FC } from 'react';

import styles from './TopBanner.module.scss';
import { Image } from '../../components/Image';

export interface BriefIntroInfo {
  briefIntro1?: string;
  briefIntro2?: string;
  briefIntro3?: string;
}
export interface BriefProps {
  briefTitle: string;
  briefBgImg: string;
  briefIntroInfo: BriefIntroInfo;
}
const TopBanner: FC<BriefProps> = (props) => {
  const { briefTitle, briefIntroInfo, briefBgImg } = props;
  // const style = {
  //   width: '100%',
  //   backgroundImage: `url(${briefBgImg})`,
  // };
  return (
    <section className={styles['top-banner-box']}>
      <div className={styles['top-banner-content-wrap']}>
        <div className={styles['top-banner-content']}>
          <div className={styles['content-title-box']}>
            <h1 className={`${styles['content-title']} mt-font`}>{briefTitle}</h1>
          </div>
          <div className={styles['content-paragraph-box']}>
            <p className={styles['content-paragraph']}>{briefIntroInfo.briefIntro1}</p>
            <div className={styles['content-intro-box']}>
              <p className={styles['content-intro']}>{briefIntroInfo.briefIntro2}</p>
              <p className={styles['content-intro']}>{briefIntroInfo.briefIntro3}</p>
            </div>
          </div>
        </div>
      </div>

      <div className={styles['top-banner-img-box']}>
        <Image width={256} height={80} src={briefBgImg} />
      </div>
    </section>
  );
};
TopBanner.defaultProps = {};

TopBanner.displayName = 'TopBanner';
export default TopBanner;
